import React from 'react'
import Modal from 'react-bootstrap/Modal'
import {KTIcon, formatNumber} from '../../../../_metronic/helpers'
interface ViewLedgerModalProps {
  showLedgerDetailsModal: boolean
  setShowLedgerDetailsModal: React.Dispatch<React.SetStateAction<boolean>>
  selectedLedgerDetails: any
}
function ViewLedgerModal({
  showLedgerDetailsModal,
  setShowLedgerDetailsModal,
  selectedLedgerDetails,
}: ViewLedgerModalProps) {
  console.log(showLedgerDetailsModal)
  console.log(selectedLedgerDetails)
  return (
    <Modal
      size='lg'
      className='modal-sticky modal-sticky-lg'
      id='ledger_details'
      data-backdrop='false'
      aria-hidden='true'
      show={showLedgerDetailsModal}
      animation={true}
    >
      <div className='modal-content'>
        {/*begin::Header*/}
        <div className='d-flex align-items-center justify-content-between py-5 ps-8 pe-5 border-bottom'>
          <h5 className='fw-bold m-0'>Ledger Details</h5>
          <div className='d-flex ms-2'>
            {/*begin::Close*/}
            <div
              className='btn btn-icon btn-sm btn-light-primary ms-2'
              data-bs-dismiss='modal'
              onClick={() => setShowLedgerDetailsModal(false)}
            >
              <KTIcon className='fs-1' iconName='cross' />
            </div>
            {/*end::Close*/}
          </div>
        </div>
        {/*end::Header*/}
        <div className='d-flex justify-content-between'>
          <div className='text-center py-5 px-5 w-50'>
            <div className='row mb-7'>
              <label className='col-lg-4 fw-bold text-muted'>Ledger Code</label>

              <div className='col-lg-8'>
                <span className={`fw-bolder fs-6 text-dark`}>
                  {selectedLedgerDetails?.ledgerCode ?? '-'}
                </span>
              </div>
            </div>

            <div className='row mb-7'>
              <label className='col-lg-4 fw-bold text-muted'>Parent Ledger</label>

              <div className='col-lg-8'>
                <span className={`fw-bolder fs-6 text-dark`}>
                  {selectedLedgerDetails?.parentLedger}
                </span>
              </div>
            </div>

            <div className='row mb-7'>
              <label className='col-lg-4 fw-bold text-muted'>Sub Ledger</label>

              <div className='col-lg-8'>
                <span className={`fw-bolder fs-6 text-dark`}>
                  {selectedLedgerDetails?.subLedger ?? '-'}
                </span>
              </div>
            </div>

            <div className='row mb-7'>
              <label className='col-lg-4 fw-bold text-muted'>Parent Group</label>

              <div className='col-lg-8'>
                <span className={`fw-bolder fs-6 text-dark`}>
                  {selectedLedgerDetails?.parentGroup ?? '-'}
                </span>
              </div>
            </div>

            <div className='row mb-7'>
              <label className='col-lg-4 fw-bold text-muted'>Sub Group</label>

              <div className='col-lg-8'>
                <span className={`fw-bolder fs-6 text-dark`}>
                  {selectedLedgerDetails?.subGroup ?? '-'}
                </span>
              </div>
            </div>

            <div className='row mb-7'>
              <label className='col-lg-4 fw-bold text-muted'>Transaction Type</label>

              <div className='col-lg-8'>
                <span className={`fw-bolder fs-6 text-dark`}>
                  {selectedLedgerDetails?.transactionType ?? '-'}
                </span>
              </div>
            </div>

            <div className='row mb-7'>
              <label className='col-lg-4 fw-bold text-muted'>Opening Balance</label>

              <div className='col-lg-8'>
                <span className={`fw-bolder fs-6 text-dark`}>
                  {formatNumber(selectedLedgerDetails?.openingBalance, 'en-IN')}
                </span>
              </div>
            </div>

            <div className='row mb-7'>
              <label className='col-lg-4 fw-bold text-muted'>As On Date</label>

              <div className='col-lg-8'>
                <span className={`fw-bolder fs-6 text-dark`}>
                  {new Date(selectedLedgerDetails?.asOnDate).toDateString().slice(4)}
                </span>
              </div>
            </div>
          </div>
          <div className='text-center py-5 px-5 w-50'>
            <div className='row mb-7'>
              <label className='col-lg-4 fw-bold text-muted'>Currency</label>

              <div className='col-lg-8'>
                <span className={`fw-bolder fs-6 text-dark`}>
                  {selectedLedgerDetails?.currency ?? '-'}
                </span>
              </div>
            </div>
            <div className='row mb-7'>
              <label className='col-lg-4 fw-bold text-muted'>Account Number</label>

              <div className='col-lg-8'>
                <span className={`fw-bolder fs-6 text-dark`}>
                  {selectedLedgerDetails?.account_number ?? '-'}
                </span>
              </div>
            </div>
            <div className='row mb-7'>
              <label className='col-lg-4 fw-bold text-muted'>Branch Name</label>

              <div className='col-lg-8'>
                <span className={`fw-bolder fs-6 text-dark`}>
                  {selectedLedgerDetails?.branch_name ?? '-'}
                </span>
              </div>
            </div>

            <div className='row mb-7'>
              <label className='col-lg-4 fw-bold text-muted'>Address</label>

              <div className='col-lg-8'>
                <span className={`fw-bolder fs-6 text-dark`}>
                  {selectedLedgerDetails?.address ?? '-'}
                </span>
              </div>
            </div>

            <div className='row mb-7'>
              <label className='col-lg-4 fw-bold text-muted'>State</label>

              <div className='col-lg-8'>
                <span className={`fw-bolder fs-6 text-dark`}>
                  {selectedLedgerDetails?.state ?? '-'}
                </span>
              </div>
            </div>

            <div className='row mb-7'>
              <label className='col-lg-4 fw-bold text-muted'>Country</label>

              <div className='col-lg-8'>
                <span className={`fw-bolder fs-6 text-dark`}>
                  {selectedLedgerDetails?.country ?? '-'}
                </span>
              </div>
            </div>

            <div className='row mb-7'>
              <label className='col-lg-4 fw-bold text-muted'>Zip Code</label>

              <div className='col-lg-8'>
                <span className={`fw-bolder fs-6 text-dark`}>
                  {selectedLedgerDetails?.zipcode ?? '-'}
                </span>
              </div>
            </div>

            <div className='row mb-7'>
              <label className='col-lg-4 fw-bold text-muted'>IFSC Code</label>

              <div className='col-lg-8'>
                <span className={`fw-bolder fs-6 text-dark`}>
                  {selectedLedgerDetails?.ifsc_code ?? '-'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ViewLedgerModal
